<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存明细记录</el-breadcrumb-item>
      </el-breadcrumb>
      <operation-help namespace="stock" help-key="bound-list" :context="{ dynamic: $route.params.dynamic || '1' }" />
    </template>
    <el-form label-width="120px" :model="querys" ref="querys" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 180px">
            <el-input v-model="querys.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-col>
            <!-- <el-switch v-model="storeSwitch" active-text="在库" inactive-text="出库"></el-switch> -->
            <el-select v-model="status" placeholder="请选择" clearable @change="statusChange();" style="width: 140px">
              <el-option key="1" label="在库货品" value="1"></el-option>
              <el-option key="0" label="出库记录" value="0"></el-option>
              <el-option key="2" label="入库记录" value="2"></el-option>

              <el-option key="3" label="借出待还" value="3" divided></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="操作类型" prop="billType">
          <el-col>
            <el-select v-model="billType" placeholder="操作类型" clearable @change="fetchs()" style="width: 140px">
              <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="单据时间">
          <el-col>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels @change="fetchs()" :shortcuts="$util.getShortCuts()"> </el-date-picker>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="系统款号" prop="detailCode">
          <el-col style="width: 180px">
            <el-input v-model="detailCode" @keyup.enter="fetchs" placeholder="精确查询"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="品牌款号" prop="brandModelCode">
          <el-col style="width: 140px">
            <el-input v-model="brandModelCode" @keyup.enter="fetchs" placeholder="精确查询"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="批次号" prop="serialCode">
          <el-col>
            <el-input v-model="serialCode" @keyup.enter="fetchs" placeholder="精确查询" style="width: 140px"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="品牌批次号" prop="brandSerialCode">
          <el-col>
            <el-input v-model="brandSerialCode" @keyup.enter="fetchs" placeholder="精确查询"
              style="width: 140px"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="规格" prop="unitName">
          <el-col>
            <el-input v-model="unitName" @keyup.enter="fetchs" style="width: 90px"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="金重(g)" prop="goldWeight">
          <el-col>
            <el-input type="number" v-model="goldWeight" @keyup.enter="fetchs" autocomplete="off"
              style="width: 90px"></el-input>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-col>
            <!-- <el-cascader v-model="companyId" :options="companys" style="width: 220px" clearable @change="fetchs()" /> -->
            <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs();" clearable
              check-strictly :render-after-expand="false" style="min-width: 220px;" />
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所在库房">
          <el-col>
            <el-select v-model="storeCode" placeholder="库房" clearable @change="fetchs()" style="width: 140px">
              <el-option v-for="item in dict.stores" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所在渠道">
          <el-col>
            <el-select v-model="channel" placeholder="渠道" clearable @change="fetchs()" style="width: 140px">
              <el-option v-for="item in dict.channels" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-col>
            <el-input v-model="remark" @keyup.enter="fetchs" style="width: 140px"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="60px">
          <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="download" @click="exportEvent()">明细导出</el-button>
      <el-button type="primary" icon="download" @click="exportStoreEvent()">在库导出</el-button>
      <el-button plain type="info" icon="upload" @click="boundModify()">批量修改货品信息</el-button>
    </div>

    <basic-table class="table" :query="querys" @handler="tableHandler" :currHandler="currHandler">

      <template v-slot:billType="scope">
        {{ scope.row.billType }}
      </template>
      <template v-slot:stockNumber="scope">
        <div v-if="scope.row.stockNumber < 0">
          <el-tag v-if="scope.row.stockStatus === 'borrowed' && scope.row.stockRemain > 0" type="danger">借出待还</el-tag>
          <el-tag v-if="scope.row.stockStatus === 'partial' && scope.row.stockRemain > 0" type="warning">部分归还</el-tag>
          <el-tag v-if="scope.row.stockStatus === 'returned' && scope.row.stockRemain == 0" type="success">借出已还</el-tag>
          <el-tag v-if="(scope.row.stockRemain || 0) == 0" type="info">出库记录</el-tag>
        </div>
        <div v-else>
          <el-tag v-if="scope.row.stockStatus === 'available' && scope.row.stockRemain > 0">在库</el-tag>
          <el-tag v-if="(scope.row.stockRemain || 0) == 0" type="info">已出库</el-tag>
        </div>
      </template>

      <template v-slot:billCode="scope">
        <el-link type="success" size="small" :underline="false" @click="openBillPage(scope.row)">{{ scope.row.billCode
        }}</el-link>
      </template>

      <template v-slot:detailImg="scope">
        <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
          :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
          <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
        </el-image>
      </template>

      <template v-slot:detailCode="scope">
        <el-link type="success" size="small" :underline="false" :href="'?detailCode=' + scope.row.detailCode">{{
          scope.row.detailCode }}</el-link>
      </template>

      <template v-slot:serialCode="scope">
        <!-- <el-link type="success" size="small" :underline="false" :href="'?serialCode='+scope.row.serialCode">{{scope.row.serialCode}}</el-link> -->
        {{ scope.row.serialCode || '' }}
      </template>

      <template v-slot:brandSerialCode="scope">
        <!-- <el-link type="success" size="small" :underline="false" :href="'?brandSerialCode='+scope.row.brandSerialCode">{{scope.row.brandSerialCode}}</el-link> -->
        {{ scope.row.brandSerialCode || '' }}
      </template>

      <template v-slot:productionDate="scope">
        {{ (scope.row.productionDate || '').split(' ')[0] }}
      </template>
      <template v-slot:warrantyExpiryDate="scope">
        <el-tag v-if="scope.row.warrantyExpiryDate" :type="new Date(scope.row.warrantyExpiryDate) < new Date() ? 'danger'
          : new Date(scope.row.warrantyExpiryDate) - new Date() <= 183 * 24 * 60 * 60 * 1000 ? 'warning' //183天的毫秒数（半年）
            : new Date(scope.row.warrantyExpiryDate) - new Date() <= 365 * 24 * 60 * 60 * 1000 ? 'primary' //365天的毫秒数（一年）
              : 'success'
          " disable-transitions>
          {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
        </el-tag>
      </template>

      <template v-slot:toolbar="scope">
        <el-button @click="edit(scope.row)" link size="small">[编辑]</el-button>
      </template>
    </basic-table>

    <stock-bound-editor
      v-model:visible="showItem"
      title="货品信息维护"
      :form-data="forms"
      :rules="rules"
      :dict="dict"
      v-model:tab-name="formTabName"
      :show-sku-selector="false"
      :lock-sku-fields="false"
      :disable-derived-prices="false"
      @item-change="handleBoundItemChange"
      @confirm="submit"
    />

    <static-dialog ref="boundModifyDialog" class="dialog" title="批量修改货品信息" :okVisible="false">
      <boundmodifypage :company-id="companyId"></boundmodifypage>
    </static-dialog>
  </el-card>
</template>

<script>
import boundmodifypage from "@/views/stock/bound/upload.vue";
import { fetchBounds, fetchBound, submitBound, exportStoreBound, boundModify } from "@/api/stock";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
import StockBoundEditor from "@/views/stock/bound/stock-bound-editor.vue";
export default {
  name: "Bound",
  components: { StaticDialog, BasicTable, boundmodifypage, StockBoundEditor },
  data() {
    return {
      apiUrl: "",
      dateRange: "",
      billType: '',
      detailCode: "",
      serialCode: "",
      brandSerialCode: "",
      brandModelCode: "",
      remark: '',
      unitName: '',
      goldWeight: '',
      status: '1',

      querys: {
        keyword: "",
        filters: [],
        columns: [
          { type: "index", label: "序号" },
          { type: "template", prop: "billType", label: "单据类型", width: "110", searchable: true, showOverflowTooltip: true, },
          { prop: "storeCode", label: "库房", sortable: true, searchable: true, width: "75", showOverflowTooltip: true, align: "center" },
          // { prop: "billCode", label: "单据编号", width: "130", sortable: true, searchable: true, },
          { type: "template", prop: "billCode", label: "单据编号", width: "100", searchable: true, showOverflowTooltip: true, },
          { prop: "channel", label: "渠道", sortable: true, searchable: true, width: "75", showOverflowTooltip: true, },
          { type: "template", prop: "detailCode", label: "款号", sortable: true, searchable: true, showOverflowTooltip: true, width: "110", },
          { prop: "brandModelCode", label: "品牌款号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, permission: 1, },
          { prop: "detailName", label: "名称", sortable: true, searchable: true, width: "170", showOverflowTooltip: true },
          { type: "template", prop: "detailImg", label: "图片", width: "50", },
          { type: "template", prop: "serialCode", label: "批次号", sortable: true, searchable: true, showOverflowTooltip: true, width: "100", },
          { prop: "weight", label: "总重(g)", width: "85", showOverflowTooltip: true, align: "center" },
          { prop: "goldWeight", label: "金重(g)", width: "90", sortable: true, showOverflowTooltip: true, align: "center" },
          { type: "template", prop: "brandSerialCode", label: "品牌批次号", sortable: true, searchable: true, showOverflowTooltip: true, width: "105", },
          { prop: "stockNumber", label: "操作数", width: "85", align: "center" },
          { prop: "stockRemain", label: "库存数", sortable: true, width: "80", showOverflowTooltip: true, align: "center" },

          { prop: "unitName", label: "规格", width: "70", sortable: true, searchable: true, showOverflowTooltip: true, },

          { prop: "goldInPrice", label: "金单价(元/g)", showOverflowTooltip: true, width: "130", align: "right", permission: 3, },
          { prop: "goldInTaxPrice", label: "含税金单价", showOverflowTooltip: true, width: "120", align: "right", permission: 3, },
          { prop: "laborUnitPrice", label: "克工费", showOverflowTooltip: true, width: "95", align: "right", permission: 3, },
          { prop: "laborUnitTaxPrice", label: "含税克工费", showOverflowTooltip: true, width: "125", align: "right", permission: 3, },
          { prop: "laborPiecePrice", label: "件工费", showOverflowTooltip: true, width: "120", align: "right", permission: 3, },
          { prop: "laborPieceTaxPrice", label: "含税件工费", showOverflowTooltip: true, width: "130", align: "right", permission: 3, },
          { prop: "otherPiecePrice", label: "其他费用", showOverflowTooltip: true, width: "105", align: "right", permission: 3, },
          { prop: "otherPieceTaxPrice", label: "含税其他费用", showOverflowTooltip: true, width: "135", align: "right", permission: 3, },

          { prop: "stoneBoundPrice", label: "镶嵌物费用", showOverflowTooltip: true, width: "120", align: "right", permission: 3, },
          { prop: "stoneBoundTaxPrice", label: "含税镶嵌物费用", showOverflowTooltip: true, width: "145", align: "right", permission: 3, },

          { prop: "purchasePrice", label: "采购价", sortable: true, showOverflowTooltip: true, width: "120", align: "right", permission: 3, },
          { prop: "useBrandPrice", label: "品牌使用费", showOverflowTooltip: true, width: "130", align: "right", permission: 3, },
          { prop: "productPrice", label: "入库价", sortable: true, showOverflowTooltip: true, width: "100", align: "right", fixed: "right", permission: 3 },
          { prop: "labelPrice", label: "标签价", showOverflowTooltip: true, width: "120", align: "right", permission: 3, },
          { prop: "sellPrice", label: "计划售价", showOverflowTooltip: true, width: "120", align: "right", permission: 3  },

          { prop: "certNumber", label: "证书号", sortable: true, searchable: true, showOverflowTooltip: true, width: "100", },

          { type: "hidden", prop: "stockStatus", label: "在库?", },
          { prop: "stockDate", label: "单据时间", sortable: true, width: "140", showOverflowTooltip: true, },
          { prop: "factoryCode", label: "供应商", sortable: true, searchable: true, showOverflowTooltip: true, width: "90", permission: 3 },
          { prop: "platformName", label: "平台名称", searchable: true, showOverflowTooltip: true, width: "95", },
          { prop: "platformOrderNo", label: "平台单号", sortable: true, searchable: true, showOverflowTooltip: true, width: "160", },
          { prop: "receiverName", label: "收货人", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "receiverMobile", label: "收货手机号", sortable: true, searchable: true, width: "120", showOverflowTooltip: true, permission: 3 },
          { prop: "outOrderNo", label: "原单号", sortable: true, searchable: true, showOverflowTooltip: true, width: "120" },
          { prop: "remark", label: "备注", searchable: true, showOverflowTooltip: true, width: "150" },
          { prop: "stockSource", label: "日志", searchable: true, showOverflowTooltip: true, width: "150" },
          { prop: "stockReason", label: "原因", searchable: true, showOverflowTooltip: true, width: "150" },

          { type: "template", prop: "productionDate", label: "生产日期", sortable: true, width: "90", },
          { type: "template", prop: "warrantyExpiryDate", label: "有效日期", sortable: true, width: "100", },

          { prop: "createDate", label: "创建时间", sortable: true, width: "140", },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "85", },
          { prop: "updateDate", label: "更新时间", sortable: true, width: "140", },
          { prop: "updateUserName", label: "更新人", sortable: true, searchable: true, width: "85", },

          { type: "template", prop: "stockNumber", label: "状态", width: "90", fixed: "right" },
          { type: "toolbar", label: "操作" },
        ],

        sidx: "stockDate",

        sord: "descending",
      },
      currRow: null,
      centerDialogVisible: false,
      dialogWidth: "30%",

      forms: {},
      showItem: false,
      labelWidth: "110px",
      rules: {},
      formTabName: "basic",

      companys: [],
      companyId: '',
      storeCode: null,
      channel: null,
      dict: {
        inBillTypes: [],
        outBillTypes: [],
        billTypes: [],
        brands: [],
        factorys: [],
        stores: [],
        channels: [],
      },
    };
  },
  mounted() {
    this.apiUrl = process.env.VUE_APP_BASEURL;

    this.$kaung.initCompanys(this, this.fetchs);
  },
  methods: {
    toNumber(val) {
      const num = Number(val);
      return Number.isFinite(num) ? num : 0;
    },
    isByWeightPriced(row) {
      const className = (row && row.className) || "";
      return className === "按克计价" || className === "按克" || className === "非一口价";
    },
    normalizeTaxFields(row) {
      if (!row) return row;
      if (row.goldInTaxPrice == null || row.goldInTaxPrice === "") row.goldInTaxPrice = this.toNumber(row.goldInPrice);
      if (row.laborUnitTaxPrice == null || row.laborUnitTaxPrice === "") row.laborUnitTaxPrice = this.toNumber(row.laborUnitPrice);
      if (row.laborPieceTaxPrice == null || row.laborPieceTaxPrice === "") row.laborPieceTaxPrice = this.toNumber(row.laborPiecePrice);
      if (row.otherPieceTaxPrice == null || row.otherPieceTaxPrice === "") row.otherPieceTaxPrice = this.toNumber(row.otherPiecePrice);
      if (row.stoneBoundTaxPrice == null || row.stoneBoundTaxPrice === "") row.stoneBoundTaxPrice = this.toNumber(row.stoneBoundPrice);
      if (row.unitPrice == null || row.unitPrice === "") row.unitPrice = 0;
      return row;
    },
    calculatePurchasePriceByTax(row, source = "") {
      if (!row) return;
      this.normalizeTaxFields(row);

      if (this.isByWeightPriced(row)) {
        const goldWeight = this.toNumber(row.goldWeight);
        const noTaxPurchasePrice =
          goldWeight * this.toNumber(row.goldInPrice) +
          goldWeight * this.toNumber(row.laborUnitPrice) +
          this.toNumber(row.laborPiecePrice) +
          this.toNumber(row.stoneBoundPrice) +
          this.toNumber(row.otherPiecePrice);
        const purchasePrice =
          goldWeight * this.toNumber(row.goldInTaxPrice) +
          goldWeight * this.toNumber(row.laborUnitTaxPrice) +
          this.toNumber(row.laborPieceTaxPrice) +
          this.toNumber(row.stoneBoundTaxPrice) +
          this.toNumber(row.otherPieceTaxPrice);
        row.noTaxPurchasePrice = Number(noTaxPurchasePrice.toFixed(2));
        row.purchasePrice = Number(purchasePrice.toFixed(2));
      }

      const stockNumber = this.toNumber(row.stockNumber);
      if (!this.isByWeightPriced(row) && source === "unitPrice") {
        row.noTaxPurchasePrice = Number((this.toNumber(row.unitPrice) * stockNumber).toFixed(2));
      } else if (!this.isByWeightPriced(row) && source === "stockNumber" && this.toNumber(row.unitPrice) > 0) {
        row.noTaxPurchasePrice = Number((this.toNumber(row.unitPrice) * stockNumber).toFixed(2));
      } else if (source === "noTaxPurchasePrice" && stockNumber > 0) {
        row.unitPrice = Number((this.toNumber(row.noTaxPurchasePrice) / stockNumber).toFixed(2));
      } else if ((source === "purchasePrice" || source === "useBrandPrice") && stockNumber > 0 && this.toNumber(row.noTaxPurchasePrice) > 0) {
        row.unitPrice = Number((this.toNumber(row.noTaxPurchasePrice) / stockNumber).toFixed(2));
      }

      const noTaxPurchasePrice = this.toNumber(row.noTaxPurchasePrice);
      const taxPrice = this.toNumber(row.taxPrice);
      const purchasePrice = this.toNumber(row.purchasePrice);
      if (purchasePrice <= 0 && (noTaxPurchasePrice > 0 || taxPrice > 0)) {
        row.purchasePrice = Number((noTaxPurchasePrice + taxPrice).toFixed(2));
      }

      row.taxPrice = Number((this.toNumber(row.purchasePrice) - this.toNumber(row.noTaxPurchasePrice)).toFixed(2));
      row.productPrice = Number((this.toNumber(row.purchasePrice) + this.toNumber(row.useBrandPrice)).toFixed(2));
    },
    validateTaxFields(row) {
      if (this.toNumber(row.purchasePrice) < this.toNumber(row.noTaxPurchasePrice)) {
        return "含税采购价必须大于等于不含税采购价";
      }
      const checks = [
        { tax: "goldInTaxPrice", base: "goldInPrice", label: "含税金单价" },
        { tax: "laborUnitTaxPrice", base: "laborUnitPrice", label: "含税克工费" },
        { tax: "laborPieceTaxPrice", base: "laborPiecePrice", label: "含税件工费" },
        { tax: "otherPieceTaxPrice", base: "otherPiecePrice", label: "含税其他费用" },
        { tax: "stoneBoundTaxPrice", base: "stoneBoundPrice", label: "含税镶嵌物费用" },
      ];
      for (const item of checks) {
        if (row[item.tax] != null && row[item.tax] !== "" && this.toNumber(row[item.tax]) < this.toNumber(row[item.base])) {
          return `${item.label}必须大于等于对应不含税字段`;
        }
      }
      return "";
    },
    validateBoundData(row) {
      if (!row.serialCode) return "请填写货品条码";
      if (!row.companyID) return "所属公司不能为空";
      if ((row.goldWeight || 0) > 0 && (row.goldInPrice == null || row.goldInPrice === "")) return `货品入库金单价不能为空${row.serialCode || ""}`;
      if ((row.goldWeight || 0) > (row.weight || 0)) return "货品金重不能大于总重";

      const className = row.className || "";
      const isByWeight = className === "按克计价" || className === "按克" || className === "非一口价";
      if (isByWeight && (this.toNumber(row.goldWeight) <= 0)) return `请补充按克计价的产品金重${row.serialCode || ""}`;

      const taxMsg = this.validateTaxFields(row);
      if (taxMsg) return taxMsg;

      if (this.toNumber(row.purchasePrice) <= 0) return `货品含税采购价错误${row.serialCode || ""}(采购价=不含税采购价+税额)`;
      if (Math.abs(this.toNumber(row.purchasePrice) - (this.toNumber(row.noTaxPurchasePrice) + this.toNumber(row.taxPrice))) > 0.01) {
        return `货品含税采购价错误${row.serialCode || ""}(采购价=不含税采购价+税额)`;
      }
      if (this.toNumber(row.productPrice) <= 0) return `货品入库价格错误${row.serialCode || ""}(产品入库价格=采购价+产品品牌使用费)`;
      if (Math.abs(this.toNumber(row.productPrice) - (this.toNumber(row.purchasePrice) + this.toNumber(row.useBrandPrice))) > 0.01) {
        return `货品入库价格错误${row.serialCode || ""}(产品入库价格=采购价+产品品牌使用费)`;
      }
      return "";
    },
    edit(row) {
      fetchBound(row.id).then((res) => {
        this.forms = { ...res.data };
        this.normalizeTaxFields(this.forms);
        this.calculatePurchasePriceByTax(this.forms, "init");
        this.formTabName = "basic";
        this.showItem = true;
      });
    },
    submit() {
      this.normalizeTaxFields(this.forms);
      this.calculatePurchasePriceByTax(this.forms, "init");
      const validMsg = this.validateBoundData(this.forms);
      if (validMsg) {
        this.$message.error(validMsg);
        return;
      }
      submitBound(this.forms).then((res) => {
        this.$message({ type: res.type, message: res.content, });
        if (res.data) {
          this.fetchs();
          this.showItem = false;
        }
      });
    },
    statusChange() {
      //在库
      if ((this.status || "") === "1" && this.dateRange && this.dateRange.length == 2) {
        this.dateRange[0] = null;
        this.dateRange[1] = null;
      }
      this.fetchs();
    },
    fetchs(methodName) {
      if ((typeof methodName) == 'object') methodName = null;
      this.querys.filters = [];
      if (this.dateRange && this.dateRange[0])
        this.querys.filters.push({ name: "stockDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2, }); if (this.dateRange && this.dateRange[1])
        this.querys.filters.push({ name: "stockDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 3, });

      if (this.detailCode)
        this.querys.filters.push({ name: "detailCode", value: this.detailCode, operate: 5, });
      if (this.brandModelCode)
        this.querys.filters.push({ name: "brandModelCode", value: this.brandModelCode, operate: 5, });
      if (this.serialCode)
        this.querys.filters.push({ name: "serialCode", value: this.serialCode, operate: 5, });
      if (this.brandSerialCode)
        this.querys.filters.push({ name: "brandSerialCode", value: this.brandSerialCode, operate: 5, });
      if (this.unitName)
        this.querys.filters.push({ name: "unitName", value: "%" + this.unitName + "%", operate: 5, });
      if (this.goldWeight && this.goldWeight > 0)
        this.querys.filters.push({ name: "goldWeight", value: this.goldWeight, operate: 0, });
      //在库
      if ((this.status || "") === "1") {
        this.querys.filters.push({ name: "stockRemain", value: "0", operate: 1, });
        this.querys.filters.push({ name: "stockStatus", value: "available", operate: 0, });
      }
      //入库记录
      if ((this.status || "") === "2") {
        this.querys.filters.push({ name: "stockNumber", value: "0", operate: 1, });
      }
      //出库
      if ((this.status || "") === "0") {
        this.querys.filters.push({ name: "stockNumber", value: "0", operate: 3, });
      }
      //借出待还
      if ((this.status || "") === "3") {
        this.querys.filters.push({ name: "stockNumber", value: "0", operate: 3, });
        this.querys.filters.push({ name: "stockStatus", value: "borrowed,partial", operate: 6, });
      }

      if (this.showOrgFilters) {
        if (!this.companyId || this.companyId.length == 0)
          this.companyId = this.$store.getters.getUserInfo?.companyID || '';
      }
      //所属公司
      if (this.showOrgFilters && this.companyId && this.companyId.length > 0) {
        this.querys.filters.push({ name: "companyId", value: this.companyId, operate: 6, });
      }

      //库房
      if (this.storeCode)
        this.querys.filters.push({ name: "storeCode", value: this.storeCode, operate: 0, });
      if (this.channel)
        this.querys.filters.push({ name: "channel", value: this.channel, operate: 0, });
      if (this.billType)
        this.querys.filters.push({ name: "billType", value: this.billType, operate: 0, });

      if (this.remark)
        this.querys.filters.push({ name: "remark", value: "%" + this.remark + "%", operate: 5, });

      let { data, records, total, ...search } = { ...this.querys, };
      search.method = methodName || '';
      fetchBounds(search).then((res) => {
        if (search.method == 'Export') {
          this.$notify({ title: "导出成功", message: res.content, type: "success", duration: 10000 });
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        }
        else {
          this.querys = { ...res.data };
        }
      });
    },
    tableHandler(query) {
      this.querys = { ...this.querys, ...query };
      this.fetchs();
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    //控制dialog宽度与子组件控制关闭弹窗
    getdialogWidth(data) {
      if (data === "80%" || data === "30%") {
        this.dialogWidth = data;
      } else {
        this.centerDialogVisible = false;
      }
    },

    exportEvent() {
      this.fetchs('Export');
    },
    exportStoreEvent() {
      if (!this.companyId) {
        this.$notify({ title: "提示", message: "请选择所属公司后再导出", type: "warning", duration: 3000 });
        return;
      }
      if ((this.companyId + '').indexOf(',') > -1) {
        this.$notify({ title: "提示", message: "仅允许选择一个所属公司进行导出", type: "warning", duration: 3000 });
        return;
      }
      this.$confirm("本次将仅导出当前所属公司的库存数据，是否继续？", "导出提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        exportStoreBound(this.companyId);
      }).catch(() => { });
    },
    boundModify() {
      this.$refs.boundModifyDialog.toggle();
    },
    openBillPage(bill) {
      let inOptions = this.dict.inBillTypes.filter(function (item) {
        return item.name == bill.billType;
      });
      if (bill.billType.indexOf('借货') > -1) {
        this.$router.push("/stock/bills/borrowDetail?billCode=" + bill.billCode);
      }
      else if (inOptions && inOptions.length > 0) {
        this.$router.push("/stock/bills/indetail?billCode=" + bill.billCode);
      } else {
        this.$router.push("/stock/bills/detail?billCode=" + bill.billCode);
      }
    },
    handleBoundItemChange(payload) {
      this.calculatePurchasePriceByTax(this.forms, (payload && payload.source) || "");
    }
  },
  watch: {
    // 监听路由参数变化
    '$route': {
      handler(to, from) {
        // 页面刷新和路由变化都会触发
        console.log('route changed:', to.params, to.query);
        this.status = to.params.dynamic || to.query.dynamic || '1';

        //不是在库的时候默认添加开始和结束时间
        if ((this.status || "") != "1") {
          this.dateRange = this.$util.getCurrentDate('recentHalfYear');
        }

        this.statusChange();
      },
      immediate: false
    },
    companyId: function (newValue, oldValue) {
      if (newValue && newValue != oldValue)
        this.$util.setLocalstorage('companyIdStr', newValue);
      else
        this.$util.setLocalstorage('companyIdStr', '');
    },
    pager: function (newValue, oldValue) {
      this.$util.setPageCache('keyword', newValue.keyword);
      if (newValue.page)
        this.$util.setPageCache('page', newValue.page);
      if (newValue.rows)
        this.$util.setPageCache('rows', newValue.rows);
      if (newValue.sidx)
        this.$util.setPageCache('sidx', newValue.sidx);
      if (newValue.sord)
        this.$util.setPageCache('sord', newValue.sord);
    },
    // status: function (newValue, oldValue) {
    //   if (newValue != oldValue)
    //     this.$util.setPageCache('status', newValue);
    // },
    storeCode: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('storeCode', newValue);
    },
  },
  created: function () {
    let that = this;

    this.$kaung.dictionary("stock", "inbound")
      .then(res => {
        that.dict.inBillTypes = res;
        that.$kaung.dictionary("stock", "outbound")
          .then(res => {
            that.dict.outBillTypes = res;
            that.dict.billTypes = that.dict.inBillTypes.concat(that.dict.outBillTypes);
          });
      });
    this.$kaung.dictionary("stock", "store").then(res => this.dict.stores = res);
    this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res);
    this.$kaung.dictionary("stock", "brand").then(res => this.dict.brands = res);
    this.$kaung.dictionary("stock", "factory").then(res => this.dict.factorys = res);

    //1在库，0出库，2入库
    //this.status = this.$route.query.status || '1';
    if (this.$route.params.dynamic) {
      this.status = this.$route.params.dynamic;
    }

    this.detailCode = this.$route.query.detailCode || '';
    this.serialCode = this.$route.query.serialCode || '';
    this.brandSerialCode = this.$route.query.brandSerialCode || '';

    this.companyId = this.$util.getLocalstorage('companyIdStr');

    this.querys.keyword = this.$util.getPageCache('keyword');

    this.querys.page = parseInt(this.$util.getPageCache('page') || 1);
    this.querys.rows = parseInt(this.$util.getPageCache('rows') || 10);

    let sidx = this.$util.getPageCache('sidx');
    if (sidx) this.querys.sidx = sidx;
    let sord = this.$util.getPageCache('sord');
    if (sord) this.querys.sord = sord;

    let storeCode = this.$util.getPageCache('storeCode');
    if (storeCode) this.storeCode = storeCode;
  }
};
</script>

<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}

.el-link {
  font-size: 0.8em;
}
</style>>
